import { Howl } from 'howler'
import { GlobalState } from '@/scripts/config/globalState'

export type ActiveSound = { sound: Howl; volume: number } | null

export type ItemSfxMeta = {
  count: number
  actual: number
  backgroundMusicVolume: number
}

export type AudioState = {
  isMuted: boolean
  isMutedManually: boolean
  sfxMeta: Record<string, ItemSfxMeta>
  currentItemSound: Howl | null
  active: Record<'music' | 'ambient', ActiveSound> & Record<string, ActiveSound>
  itemSoundPool: Record<string, Howl>
}

export let chosenMusicIdx: number | null = null

export const state: AudioState = {
  isMuted: false,
  isMutedManually: false,
  sfxMeta: {},
  currentItemSound: null,
  active: { music: null, ambient: null },
  itemSoundPool: {},
}

export function setChosenMusicIdx(idx: number | null): void {
  chosenMusicIdx = idx
}

export function getChosenMusicIdx(): number | null {
  return chosenMusicIdx
}

export function initSfxMeta(): void {
  state.sfxMeta = Object.fromEntries(
    Object.entries(GlobalState.itemsConfig).map(([key, info]) => [
      key,
      {
        count: info.numSounds,
        actual: 0, // Always start from 0, so first play will be frame 1
        backgroundMusicVolume: info.backgroundMusicVolume,
      } as ItemSfxMeta,
    ]),
  )
}
